import { ISpinParameters } from '@GFTypes/GameStoreTypes/SpinParameters';
import { SPIN_PARAMETERS_DEFAULTS } from './SpinParametersDefaults';

export const SPIN_PARAMETERS_SETS_DEFAULTS: ISpinParameters[] = [SPIN_PARAMETERS_DEFAULTS];
